import React from "react";
import { createRoot } from "react-dom/client";
import App from "../snacks/App";
import { UserProvider } from "../utensils/UserContext";
import { ConfigProvider } from "../utensils/ConfigContext";
import { StatusBoardProvider } from "../utensils/StatusBoardContext"; // Nuevo proveedor de estados

// Obtén el contenedor raíz desde el DOM
const container = document.getElementById("root");
const root = createRoot(container);

// Renderiza la aplicación con todos los proveedores de contexto
root.render(
  <ConfigProvider>
    <UserProvider>
      <StatusBoardProvider>
        <App />
      </StatusBoardProvider>
    </UserProvider>
  </ConfigProvider>
);

/* ============================
   🚀 PWA: Registro de SW + Install Prompt
   ============================ */

// 1) Registrar el Service Worker (Parcel resuelve la URL en build)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      // Este archivo debe existir en: src/sw.js
      .register(new URL("../sw.js", import.meta.url))
      .then(() => console.log("[PWA] Service Worker registrado"))
      .catch((err) => console.error("[PWA] Error registrando SW:", err));
  });
}

// 2) Manejo del beforeinstallprompt para mostrar botón propio
//    Exponemos una API mínima en window.pwaInstall para que cualquier componente
//    pueda disparar la instalación (ej: botón en la navbar)
(() => {
  let deferredPrompt = null;

  // namespace seguro
  window.pwaInstall = window.pwaInstall || {
    available: false,
    /**
     * Dispara el prompt nativo de instalación si está disponible.
     * Retorna { outcome: 'accepted' | 'dismissed' | 'unavailable' }
     */
    prompt: async () => {
      if (!deferredPrompt) return { outcome: "unavailable" };
      deferredPrompt.prompt();
      const result = await deferredPrompt.userChoice;
      // una vez usado, se invalida
      deferredPrompt = null;
      window.pwaInstall.available = false;
      // avisar al resto de la app que ya no hay prompt disponible
      window.dispatchEvent(
        new CustomEvent("pwa:prompt-used", { detail: result })
      );
      return result;
    },
  };

  // Captura del evento del navegador
  window.addEventListener("beforeinstallprompt", (e) => {
    // Evitamos que el navegador muestre el banner automático
    e.preventDefault();
    deferredPrompt = e;
    window.pwaInstall.available = true;
    // Notifica a la app que el prompt está listo (tu UI puede mostrar un botón)
    window.dispatchEvent(new CustomEvent("pwa:beforeinstallprompt"));
    console.log("[PWA] beforeinstallprompt listo");
  });

  // Evento cuando la PWA se instaló
  window.addEventListener("appinstalled", () => {
    console.log("[PWA] App instalada");
    window.pwaInstall.available = false;
    window.dispatchEvent(new CustomEvent("pwa:installed"));
  });
})();
